import React from 'react';
import AutenticacaoConsumer from '../../providers/autenticacao/AutenticacaoConsumer';
import { Loading } from '../../presentations';

function LogoutPage() {
    return (<AutenticacaoConsumer>
        {({ logout }) => {
            logout();
            return <Loading />
        }}
    </AutenticacaoConsumer>);
}

export default LogoutPage;